import actionTypes from 'SRC/modules/redux/actionTypes'
import initialState from 'SRC/modules/redux/initialState'

export const productsReducer = (state = initialState.ads.products, action) => {
  switch (action.type) {
    case actionTypes.SET_PRODUCTS:
      return {
        ...state,
        elements: action.payload
      }
    case actionTypes.SET_PRODUCTS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      }
    case actionTypes.RESET_PRODUCTS:
      return {
        ...state,
        elements: []
      }
    default:
      return state
  }
}
